import * as L from 'leaflet';

const MarkerIcon = function(size: number, color: string) {
  const html = 
    '<svg xmlns="http://www.w3.org/2000/svg" width="size" height="size" viewBox="0 0 1000 1000"> \
      <circle cx="500" cy="500" r="249.5" fill="color" stroke="black" stroke-width="10%" stroke-opacity="50%" stroke-miterlimit="10"/> \
    </svg>'
    .replace(/size/g, size.toString())
    .replace(/color/g, color);  
  return L.divIcon({
    html: html,
    className: "", // The classNameproperty is set to an empty string to keep Leaflet from adding the new icon to the leaflet-div-icon class. 
    iconSize: [size, size],
    iconAnchor: [size/2, size/2],    
  });
}

export { MarkerIcon }